import styled from 'styled-components';

export const FieldTabSelectOption = styled.div({
  backgroundColor: (props) =>
    props.$isSelected ? props.colors.gray[1] : props.$colors.gray[0],
  ':hover': {
    backgroundColor: (props) => props.$colors.true_gray[2],
  },
});
